// Owner supplied; Kakao community title and participation page checked 2026-09-08.
export const loungeUrl: string | null = "https://open.kakao.com/o/p32AnyMi";
export function verifiedLoungeUrl(value: string | null): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && url.hostname === "open.kakao.com" && !url.port && !url.username && !url.password && /^\/o\/[a-zA-Z0-9]+$/.test(url.pathname) && !url.search && !url.hash ? url.href : null;
  } catch { return null; }
}
